import { useState, useEffect } from 'react';
import './floatingCTA.css';

const FloatingCTA = () => {

  const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            // Show button if scrolled more than 100vh
            if (window.scrollY > window.innerHeight) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

  return (
    <a 
            href="tel:0412279273" 
            className={`floating-cta ${isVisible ? 'visible' : 'hidden'}`}
            aria-hidden={!isVisible}
            tabIndex={isVisible ? 0 : -1}
        >
            <span className="cta-icon">
                <svg width="18" height="18" fill="#fff" viewBox="0 0 16 16" aria-hidden="true">
                  <path fillRule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
                </svg>
            </span>
            <span className="cta-text">Call Now</span>
        </a>
  );
};

export default FloatingCTA;
